var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showLabel)?_c('label',{staticClass:"label items-center capitalize max-w-full",attrs:{"for":_vm.context.id}},[_c('span',{staticClass:"break-all",domProps:{"textContent":_vm._s(_vm.context.label)}}),(_vm.isRequired)?_c('span',{staticClass:"text-red-500 ml-1 text-lg leading-3 mr-auto"},[_vm._v(" * ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }